import React from 'react'
import { useHref, useNavigate, useParams } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'
import { InfoLinkSection } from 'src/components/Reusable/Text/InfoLink.styles'
import {
  StandardButton,
  StandardButtonSize,
  StandardButtonVariant,
} from 'src/components/Reusable/Buttons'
import { ControlsAbsoluteRoutes } from 'src/components/Reusable/RootPage/RootPage.constants'
import { UrlFragments } from 'src/Utils/globalEnums'
import { HelpPages } from 'src/pages/Help/Help.constants'
import { useFlatHelpPage } from 'src/context/Gatekeeper'
import { LearnMoreLink } from 'src/components/Reusable/Text/Link'
import {
  AuditBotEmptyContainer,
  AuditBotControlsEmptyIcon,
  AuditBotEmptyTitle,
  AuditBotEmptyDescription,
  AuditBotEmptyButtonContainer,
} from '../AuditBotModal.styles'

export const AuditBotControlsDescription = (): JSX.Element => {
  const isFlatHelpEnabled = useFlatHelpPage()
  const infoLink = useHref({
    pathname: `../../help/overview`,
    hash: `${UrlFragments.CONTROLS}`,
  })

  return (
    <InfoLinkSection>
      Control Test will test these controls. All controls must pass for audit
      readiness.{' '}
      {isFlatHelpEnabled ? (
        <LearnMoreLink href={HelpPages['Overview'].link} />
      ) : (
        <HashLink to={infoLink}>Learn more</HashLink>
      )}
    </InfoLinkSection>
  )
}

export const AuditBotControlsEmptyState = ({
  onHide,
}: {
  onHide: () => void
}): JSX.Element => {
  const navigate = useNavigate()
  const params = useParams()
  const url = `/${params.pageContext}/${ControlsAbsoluteRoutes.INDEX}`

  return (
    <AuditBotEmptyContainer>
      <AuditBotEmptyTitle>
        <AuditBotControlsEmptyIcon />
        This audit contains no controls.
      </AuditBotEmptyTitle>
      <AuditBotEmptyDescription>
        The audit must contain controls before testing can begin.
      </AuditBotEmptyDescription>
      <AuditBotEmptyButtonContainer>
        <StandardButton
          buttonSize={StandardButtonSize.MEDIUM}
          variant={StandardButtonVariant.PRIMARY}
          onClick={(e: React.MouseEvent) => {
            e.preventDefault()
            onHide()
            navigate(url)
          }}
        >
          Add Controls to the Audit
        </StandardButton>
      </AuditBotEmptyButtonContainer>
    </AuditBotEmptyContainer>
  )
}
